import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {NotificationType, Toaster} from './toaster.interface';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  private toaster = new Subject<Toaster>();

  constructor() {
  }

  // Success message
  success(text: string, duration?: number): void {
    this.toaster.next({
      type: NotificationType.Success,
      message: text,
      duration,
    } as Toaster);
  }

  // Error message
  error(text: string, duration?: number): void {
    this.toaster.next({
      type: NotificationType.Error,
      message: text,
      duration,
    } as Toaster);
  }

  // Info message
  info(text: string, duration?: number): void {
    this.toaster.next({
      type: NotificationType.Info,
      message: text,
      duration,
    } as Toaster);
  }

  // Warning message
  warning(text: string, duration?: number): void {
    this.toaster.next({
      type: NotificationType.Warning,
      message: text,
      duration,
    } as Toaster);
  }

  getToaster(): Observable<any> {
    return this.toaster.asObservable();
  }
}
